import React from 'react';

function buildPageWindow(currentPage, totalPages) {
  const delta = 1;
  const pages = [];
  const left = Math.max(2, currentPage - delta);
  const right = Math.min(totalPages - 1, currentPage + delta);

  pages.push(1);

  if (left > 2) {
    pages.push('...');
  }

  for (let page = left; page <= right; page += 1) {
    pages.push(page);
  }

  if (right < totalPages - 1) {
    pages.push('...');
  }

  if (totalPages > 1) {
    pages.push(totalPages);
  }

  return pages;
}

function CompactPagination({
  currentPage,
  totalPages,
  totalCount,
  itemLabel,
  previousLabel,
  nextLabel,
  onPageChange,
  className = '',
  ariaLabel = 'Pagination',
}) {
  if (totalPages <= 1) return null;

  const safePreviousLabel = previousLabel || 'Previous';
  const safeNextLabel = nextLabel || 'Next';
  const safeItemLabel = itemLabel || 'items';
  const pages = buildPageWindow(currentPage, totalPages);
  const wrapperClassName = ['compact-pagination', className].filter(Boolean).join(' ');

  return (
    <div className={wrapperClassName}>
      <nav className="compact-pagination__nav" aria-label={ariaLabel}>
        <ul className="pagination compact-pagination__list mb-0">
          <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
            <button
              type="button"
              className="page-link"
              aria-label={safePreviousLabel}
              title={safePreviousLabel}
              onClick={() => {
                if (currentPage > 1) onPageChange(currentPage - 1);
              }}
              disabled={currentPage <= 1}
            >
              &lsaquo;
            </button>
          </li>

          {pages.map((page, index) => {
            if (page === '...') {
              return (
                <li key={`compact-gap-${index}`} className="page-item disabled">
                  <span className="page-link">&hellip;</span>
                </li>
              );
            }

            const isActive = page === currentPage;

            return (
              <li key={page} className={`page-item ${isActive ? 'active' : ''}`}>
                <button
                  type="button"
                  className="page-link"
                  aria-current={isActive ? 'page' : undefined}
                  onClick={() => onPageChange(page)}
                >
                  {page}
                </button>
              </li>
            );
          })}

          <li className={`page-item ${currentPage >= totalPages ? 'disabled' : ''}`}>
            <button
              type="button"
              className="page-link"
              aria-label={safeNextLabel}
              title={safeNextLabel}
              onClick={() => {
                if (currentPage < totalPages) onPageChange(currentPage + 1);
              }}
              disabled={currentPage >= totalPages}
            >
              &rsaquo;
            </button>
          </li>
        </ul>
      </nav>

      <small className="compact-pagination__meta">
        {totalCount} {safeItemLabel}
      </small>
    </div>
  );
}

export default CompactPagination;
